import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  DialogTitle,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  TextField,
  IconButton,
  Grid
} from "@mui/material";
import { UrlApiEnvasado } from "../../../services/apirest";
import ArrowBackIcon from "@mui/icons-material/ArrowBack"; // Icono de retroceso
import { grey } from "@mui/material/colors";

function DialogListadoSuc(props) {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setLoading(true);
    fetch(`${UrlApiEnvasado}api/estadistica/xsucursal/listadoclientes/${props.fechaDesde}/${props.fechaHasta}/${props.sucursal}`)
      .then((res) => res.json())
      .then((data) => {
        setClientes(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error al obtener clientes:", error);
        setLoading(false);
      });
  }, []);

  const handleClose = () => {
    props.setOpen(false);
  };

  const filteredClientes = clientes.filter(cliente =>
    cliente.ccd_cliente_adi.toString().includes(search) ||
    (cliente.nombre_cliente && cliente.nombre_cliente.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <Dialog fullWidth open={props.open} onClose={handleClose} maxWidth="md">
      <Box justifyContent="center" backgroundColor="#1F618D">
        {/* <DialogTitle> */}
        <Grid container backgroundColor="#1F618D" p={1}>
            <Grid item xs={2}>
              <IconButton onClick={handleClose}>
                <ArrowBackIcon sx={{ color: grey[50] }} />
              </IconButton>
            </Grid>
            <Grid
              item
              xs={8}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
          <Typography fontSize={20} align="center" color="#ffffff">
            Listado de Clientes
          </Typography>
          </Grid>
          </Grid>
        {/* </DialogTitle> */}
      </Box>
      <DialogContent>
        <TextField
          fullWidth
          margin="dense"
          label="Buscar Cliente"
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        {loading ? (
          <Box display="flex" justifyContent="center" p={2}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><b>ID Cliente</b></TableCell>
                  <TableCell><b>Nombre</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredClientes.length > 0 ? (
                  filteredClientes.map((cliente) => (
                    <TableRow key={cliente.ccd_cliente_adi}>
                      <TableCell>{cliente.ccd_cliente_adi}</TableCell>
                      <TableCell>{cliente.nombre_cliente || "Sin nombre"}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      No hay clientes disponibles
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default DialogListadoSuc;
